import { atom } from "recoil";

const showClipboardAtom = atom({
  key: "showClipboard",
  default: false,
});

export default showClipboardAtom;
